module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Increments/increments-sanction/increments-sanction-grid/increments-sanction-grid.component.css
// module id = ./src/app/hrms/Increments/increments-sanction/increments-sanction-grid/increments-sanction-grid.component.css
// module chunks = main